import { NavLink } from "react-router-dom"
import menuCommunityIcon from "../../assets/img/menu-community.svg"
import menuNewsletterIcon from "../../assets/img/menu-newsletter.svg"
import menuProducts from "../../assets/img/menu-products.svg"
import menuOrders from "../../assets/img/menu-orders.svg"
import closedArrow from "../../assets/img/sidebar-close.svg"
import openedArrow from "../../assets/img/sidebar-open.svg"
import menuProfileSettings from "../../assets/img/menu-payout-settings.svg"
import notConnected from "../../assets/img/payout-settings-not-connected.svg";
import { useDispatch, useSelector } from "react-redux"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import usericon from "../../assets/img/products/usericon.svg"
import calendarSidebarIcon from "../../assets/img/products/calendarSidebarIcon.svg"
import StarIcon from "../../assets/img/star.svg"
import { useEffect, useState } from "react"
import { showLoader, hideLoader } from "../../components/loader";
import { apiUrl, appUrl } from "../../utils/url"
import chevronDown from "../../assets/img/chevron-down.svg";
import DashboardProjectsModal from "../dashboard/projects/modal"
import broadcastIcon from "../../assets/img/broadcast-icon.svg"
import analyticsIcon from "../../assets/img/line-chart.svg"

const NewBottomBar = ({ profile, title,changeProject,basePathState,  setSelectedProject, isLoading, sharedProjects, projects, handleOpenModal,  selectedSlug }) => {
    const dispatch = useDispatch();
    const  { slug } = useSelector(state => state?.slugReducer);
    // useEffect(()=>{
    //     if (basePath == null) {
    //         dispatch({ type: "SET_SLUG", payload: {basePath: "/project/" + localStorage?.slug } })
    //     }
    // },[basePath])
    useEffect(() => {
        document.addEventListener('DOMContentLoaded', function() {
            var headerDropdown = document.querySelector('#project-dropdown');
            headerDropdown.onclick = () => headerDropdown.classList.toggle('active');
        });
    });
    return(
        <>
            <div class="bottom-navbar">
                <div class="navbar-items">
                    <NavLink to={`${basePathState}/campaigns`} activeClassName="active" className="">
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                            <path d="M10 3.12132H5.8C4.11984 3.12132 3.27976 3.12132 2.63803 3.4483C2.07354 3.73592 1.6146 4.19486 1.32698 4.75935C1 5.40109 1 6.24116 1 7.92132V16.3213C1 18.0015 1 18.8416 1.32698 19.4833C1.6146 20.0478 2.07354 20.5067 2.63803 20.7943C3.27976 21.1213 4.11984 21.1213 5.8 21.1213H14.2C15.8802 21.1213 16.7202 21.1213 17.362 20.7943C17.9265 20.5067 18.3854 20.0478 18.673 19.4833C19 18.8416 19 18.0015 19 16.3213V12.1213M6.99997 15.1213H8.67452C9.1637 15.1213 9.40829 15.1213 9.63846 15.0661C9.84254 15.0171 10.0376 14.9363 10.2166 14.8266C10.4184 14.7029 10.5914 14.53 10.9373 14.1841L20.5 4.62132C21.3284 3.79289 21.3284 2.44975 20.5 1.62132C19.6716 0.792894 18.3284 0.792893 17.5 1.62132L7.93723 11.1841C7.59133 11.53 7.41838 11.7029 7.29469 11.9048C7.18504 12.0837 7.10423 12.2788 7.05523 12.4829C6.99997 12.713 6.99997 12.9576 6.99997 13.4468V15.1213Z" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        
                    </NavLink>

                    <NavLink to={`${basePathState}/leads`} activeClassName="active" className="">
                        <img src={menuCommunityIcon} width="20px" alt="" />
                        
                    </NavLink>
                    <NavLink to={`${basePathState}/analytics`} activeClassName="active" className="left-menu-item">
                        <img src={analyticsIcon} width="16px" height="16px" alt=""/>
                    </NavLink> 
                </div>
                    <div className="project-dropdown dropdown-toggle noselect" id="project-dropdown" data-bs-toggle="dropdown" aria-expanded="false" >
                        <img src={profile} alt="" width="45" />
                    <ul className="project-dropdown-menu dropdown-menu "style={{position:"fixed",bottom:"123px", top:"auto"}} aria-labelledby="project-dropdown">
                        {projects?.map((value, index) => (
                            <li>
                            <div className="project-dropdown-item share-dropdown-item d-flex align-items-center ps-1" 
                                style={localStorage.slug === value.slug ? { color: "#4397F7" ,background:"#F3F3F3",borderRadius:"10px"} : null}
                                onClick={(e) => { localStorage.slug = value.slug
                                changeProject(e, value.id, value?.slug) }}>
                                <div className="d-flex justify-content-start"><img src={value?.settings[1]?.value} alt="" width="25" /></div>
                                <div className="d-flex ps-2 w-100">
                                    @{value?.slug}
                                </div>
                                {localStorage.slug == value.slug &&
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                        <rect x="1.0918" y="8.70801" width="6.53375" height="1.99973" rx="0.999867" transform="rotate(33.1196 1.0918 8.70801)" fill="#1188FF"/>
                                        <rect x="12.2461" y="3.57031" width="12.3984" height="1.99973" rx="0.999867" transform="rotate(123.12 12.2461 3.57031)" fill="#1188FF"/>
                                    </svg>
                                }
                            </div>
                            </li>
                        ))}
                        {sharedProjects?.length >= 1 &&
                        sharedProjects.map((value, index) => (
                            <>
                            <li>
                            <b>Shared Projects</b>
                            </li>
                            <li>
                            <div className="project-dropdown-item share-dropdown-item d-flex align-items-center ps-1" 
                                style={localStorage.slug === value.slug ? { color: "#4397F7" ,background:"#F3F3F3",borderRadius:"10px"} : null}
                                onClick={(e) => {
                                    localStorage.slug = value?.project?.slug
                                    changeProject(e, value?.id, value?.project?.slug)
                                    setSelectedProject(false);
                                }}>
                                <div className="d-flex justify-content-start"><img src={value?.project?.settings[1]?.value} alt="" width="25" /></div>
                                <div className="d-flex ps-2 w-100">
                                    @{value?.project?.slug}
                                </div>
                                {localStorage.slug == value.slug &&
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                        <rect x="1.0918" y="8.70801" width="6.53375" height="1.99973" rx="0.999867" transform="rotate(33.1196 1.0918 8.70801)" fill="#1188FF"/>
                                        <rect x="12.2461" y="3.57031" width="12.3984" height="1.99973" rx="0.999867" transform="rotate(123.12 12.2461 3.57031)" fill="#1188FF"/>
                                    </svg>
                                }
                            </div>
                            </li>
                        </>
                        ))
                        }
                        <li>
                            <div className="project-dropdown-item dropdown-item d-flex align-items-center ps-1 " onClick={handleOpenModal}>
                                <div className="ms-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                        <path d="M6.64084 1.64085C6.64084 1.14885 6.242 0.75 5.75 0.75C5.258 0.75 4.85915 1.14884 4.85915 1.64085V11.3592C4.85915 11.8512 5.258 12.25 5.75 12.25C6.242 12.25 6.64084 11.8512 6.64084 11.3592V1.64085Z" fill="#333333"/>
                                        <path d="M0.890844 5.60916C0.398845 5.60916 0 6.008 0 6.5C0 6.992 0.398845 7.39085 0.890844 7.39085L10.6092 7.39085C11.1012 7.39085 11.5 6.992 11.5 6.5C11.5 6.008 11.1012 5.60915 10.6092 5.60915L0.890844 5.60916Z" fill="#333333"/>
                                    </svg>
                                </div>
                                <div className="d-flex flex-column ps-2 ms-2">Create New Workspace</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </>
   )

}
export default NewBottomBar